import styled from 'styled-components';

interface BadgeContainerProps { backgroundColor?: string; }
export const BadgeContainer = styled.div<BadgeContainerProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ backgroundColor }) => backgroundColor ? backgroundColor : '#ffffff'};
    border-radius: 50%;
    width: 60px;
    height: 60px;
`;